// EOS Admin API client + helpers. All EOS routes require the founder
// ADMIN_KEY, stored in localStorage after gate submission.
import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const KEY_STORAGE = "eos_admin_key";

export function getAdminKey() {
  try { return localStorage.getItem(KEY_STORAGE) || ""; } catch { return ""; }
}
export function setAdminKey(k) {
  try { localStorage.setItem(KEY_STORAGE, k); } catch { /* ignore */ }
}
export function clearAdminKey() {
  try { localStorage.removeItem(KEY_STORAGE); } catch { /* ignore */ }
}

export function eosApi() {
  const client = axios.create({
    baseURL: `${BASE}/api/eos`,
    headers: { "X-Admin-Key": getAdminKey() },
  });
  client.interceptors.response.use(
    (r) => r,
    (err) => {
      if (err?.response?.status === 401) clearAdminKey();
      return Promise.reject(err);
    },
  );
  return client;
}
